import * as React from 'react';
import s from './Totals.scss';
import get from 'lodash.get';
import { Text } from '@wix/design-system';
import { withTranslation } from '@wix/fe-essentials/i18n';
import { currencyFormat } from '../../../core';
const Totals = ({ t, priceQuote, locale }) => {
    const subtotal = get(priceQuote.totals, 'subtotal.serializedValue', 0);
    const discountAmount = get(priceQuote.totals, 'discountAmount.serializedValue', 0);
    const total = get(priceQuote.totals, 'total.serializedValue', 0);
    const fees = get(priceQuote.totals, 'fees');
    const rate = get(priceQuote.discount, 'percentage.serializedValue');
    const taxes = get(priceQuote.taxes, 'taxes');
    const format = currencyFormat({
        locale,
        currency: priceQuote.currencyCode,
    });
    const subtotalModifiersActive = !!fees || !!rate || !!taxes;
    return (React.createElement("div", { className: s.totals },
        React.createElement("div", { className: s.total },
            React.createElement(Text, { weight: subtotalModifiersActive ? 'bold' : 'thin', dataHook: "subtotal-label" }, t('invoice-view:price-quote.view.totals.subtotal')),
            React.createElement("div", { className: s.totalValue },
                React.createElement(Text, { weight: subtotalModifiersActive ? 'bold' : 'thin', dataHook: "subtotal-text" }, format(subtotal)))),
        !!fees &&
            fees.map(({ name, price }) => typeof price?.serializedValue === 'number' &&
                price.serializedValue !== 0 && (React.createElement("div", { key: `fee-${name}`, className: s.total },
                React.createElement(Text, { weight: "thin", dataHook: `fee-${name}-name` }, name),
                React.createElement("div", { className: s.totalValue },
                    React.createElement(Text, { weight: "thin", dataHook: `fee-${name}-value` }, format(price.serializedValue)))))),
        !!rate && (React.createElement("div", { className: s.total },
            React.createElement(Text, { weight: "thin", dataHook: "discount-label" }, t('invoice-view:price-quote.view.totals.discount', { rate })),
            React.createElement("div", { className: s.totalValue },
                React.createElement(Text, { weight: "thin", dataHook: "discount-text" }, format(discountAmount))))),
        !!taxes &&
            taxes
                .filter((tax) => !!(tax.taxed?.serializedValue && tax.rate))
                .map(({ taxed: { serializedValue: taxed }, rate: { serializedValue: taxRate }, name, }) => {
                return (typeof taxed === 'number' &&
                    taxed !== 0 && (React.createElement("div", { key: `${name}-${taxRate}`, className: s.total },
                    React.createElement(Text, { weight: "thin", dataHook: `tax-${name}-${taxRate}-name` }, t('invoice-view:price-quote.view.totals.tax-rate', {
                        rate: taxRate,
                        name,
                    })),
                    React.createElement("div", { className: s.totalValue },
                        React.createElement(Text, { weight: "thin", dataHook: `tax-${name}-${taxRate}-taxed` }, format(taxed))))));
            }),
        React.createElement("div", { className: s.quoteTotal },
            React.createElement(Text, { weight: "thin", size: "medium", dataHook: "total-label" }, t('invoice-view:price-quote.view.totals.total')),
            React.createElement(Text, { className: s.totalValue, weight: "bold", size: "medium", dataHook: "total-text" }, format(total)))));
};
export default withTranslation(['invoice-view', 'locale-data'])(Totals);
//# sourceMappingURL=Totals.js.map